var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommuMediaAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.47 7.53553L9.0533 12.9522C8.72178 13.2837 8.53553 13.7334 8.53553 14.2022C8.53553 14.671 8.72178 15.1207 9.0533 15.4522C9.38482 15.7837 9.83446 15.97 10.3033 15.97C10.7721 15.97 11.2218 15.7837 11.5533 15.4522L16.97 10.0355C17.633 9.37249 18.0055 8.47322 18.0055 7.53553C18.0055 6.59785 17.633 5.69858 16.97 5.03553C16.3069 4.37249 15.4076 4 14.47 4C13.5323 4 12.633 4.37249 11.97 5.03553L6.5533 10.4522C5.55874 11.4468 5 12.7957 5 14.2022C5 15.6087 5.55874 16.9576 6.5533 17.9522C7.54786 18.9468 8.89678 19.5055 10.3033 19.5055C11.7098 19.5055 13.0587 18.9468 14.0533 17.9522L19.47 12.5355",
    stroke: "#FF6019",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommuMediaAttachment);
export default __webpack_public_path__ + "static/media/CommuMediaAttachment.414f732d.svg";
export { ForwardRef as ReactComponent };